const baseStyle = {};
const defaultProps = {
    size: 'md'
};
const parts = ['stepHorizontal'];
const sizes = {
    sm: {},
    md: {}
};
const variants = {};
export default {
    baseStyle,
    defaultProps,
    parts,
    sizes,
    variants
};
